import $ from "jquery"
import _ from "underscore"
import {bindActionCreators} from 'redux'
import CustomerPanel, {CustomerPanelDialogs} from "./CustomerPanel"
import CustomerStore from "../../store/CustomerStore"
import messageResource from "../../messageResource"
import makeRpcCall from "../../util/jquery_rpc"
import AuditHistoryView from "../auditHsitory/AuditHistoryView"
import {customerActionsProvider} from "../actionsProviders"
import {applyActionResultToAssignedUsersEditor} from "../applyAction"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from "../errors"
import {selectFirstStatusByType, selectStatusById} from "../../workflowStatus/selectors"
import {connect, unsafe_selectWithState} from '../../redux/utils'
import {WorkflowStatusType} from "../../workflowStatus/constants"
import PanelContainer from "../../components/PanelContainer"
import LoadingContainer from "../../util/LoadingContainer"
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from "../constants"
import {resolveAuditActions} from "../utils"
import {AuditEntityTypes} from "../auditHsitory/constants"
import UserNameFormat from '../../util/UserNameFormat'
import {copyLinkTo, reloadComments, setAllProjectsAssigned, setCanManageCustomer} from './actions'
import StateComponent from '../../StateComponent'
import {getOpenCustomerId, isPanelOpenedFromUrl} from './selectors'
import {archiveProjectsOfCustomerAndReloadTasks, removeCustomer} from '../../taskManagement/common/actions'
import {addCustomer} from '../../entities/actions'
import {isTWSEnabled, isWASEnabled} from '../../features/selectors'
import {toast, warning} from '../../toasts/actions'

class CustomerPanelController extends StateComponent {
    constructor({
        onCustomerArchived = () => {},
        onCustomerChanged = () => {},
        onCustomerDeleted = () => {},
        loadComments = () => {},
        setAllProjectsAssigned = () => {},
        setCanManageCustomer = () => {},
        copyLink = () => {},
        toast = () => {},
        warning = () => {},
    }) {
        super()

        this.state =  {
            customerId: null,
            openedFromUrl: false,

            assignedUsersData: {},
            assignedUsersDataForManagers: {},
            customerInfo: {},
            customerSpentTimeValues: {},
            enabledFeatures: [],
            allAuditHistoryLoaded: false,

            isWASEnabled: false,
            isTWSEnabled: false,
        }

        this.actions = {
            onCustomerArchived,
            onCustomerChanged,
            onCustomerDeleted,
            loadComments,
            setAllProjectsAssigned,
            setCanManageCustomer,
            copyLink,
            toast,
            warning,
        }

        this.onStatePropertyChanged('customerId', (customerId, prevCustomerId) => {
            this.panelContainer.setState({isShown: customerId !== null})
            if (customerId && customerId !== prevCustomerId)
                this.loadData(customerId)
        })
    }

    init() {
        const $taskBlock = $("#taskListBlock");
        const $page = $('#taskManagementPage');

        this.panel = new CustomerPanel({
            updateDescription: description => this._updateDescription(description),
        });
        this.loadingContainer = new LoadingContainer({
            $containerEl: null,
            contentComponent: this.panel,
            containerClass: "",
            proxySetState: false,
        })
        this.panelContainer = new PanelContainer({
            component: this.loadingContainer,
            showCopyLink: true,
            copyLinkTooltipText: messageResource.getMessage('customer.edit_panel.copy_link_tooltip_text'),
            showHideButton: true,
            additionalClass: 'edit_customer_sliding_panel sliding_panel',
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_RIGHT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_RIGHT,

            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                outsideElement: $page,
                panelType: PANEL_TYPES.EDIT_CUSTOMER,
            },
            onClickCloseButton: () => this.panelContainer.setState({isShown: false}),
            onShowCallback: () => {
                this.panel.onShow()
            },
            onHideCallback: () => {
                this.customerId = null;
                this.panel.onHide()
            },
            onCopyLinkClick: () => this.actions.copyLink(),
            hideHandler: () => this.panelContainer.setState({isShown: false}),
        }).init($taskBlock)

        this.subscribeForEvents();
        return this;
    }

    subscribeForEvents() {
        const panel = this.panel;

        panel.archiveDialog.on("archived", (e, id) => {
            this._makeUpdateRequest("CustomerInfoService.setCustomerActive", [this.customerId, false], panel.detailsTab.details.statusButton, true, id);
        });

        panel.archiveDialog.on("cancel", () => {
            panel.openLastSelectedTab()
            panel.update(this.state)
        });

        panel.header.nameInput.on('change', (e, text) => {
            this.customerId && this._makeUpdateRequest("CustomerInfoService.setCustomerName", [this.customerId, text], panel.header.nameInput);
        });

        panel.on('cancelDelete', () => {
            panel.openLastSelectedTab()
        });

        panel.detailsTab.details.statusButton.on('change', (e, active) => {
            this._makeUpdateRequest("CustomerInfoService.setCustomerActive", [this.customerId, active], panel.detailsTab.details.statusButton, false, null);
        });

        panel.on('delete', (e, revokeStatuses) => {
            $(this).trigger("deleteBegin");

            const customerId = this.customerId;
            makeRpcCall("CustomerInfoService.deleteCustomer",
                    [customerId, revokeStatuses],
                    () => {
                        $(this).trigger("deleteEnd");
                        const customerName = CustomerStore.get(customerId).name;
                        this.actions.toast(messageResource.getMessage("delete.customer.toast", [customerName]));
                        this.actions.onCustomerDeleted(customerId)
                        this.hidePanel();
                    },
                    (jqXHR, textStatus, errorThrown) => {
                        $(this).trigger("deleteEnd");

                        return !!this._errorHandler(customerId, jqXHR, textStatus, errorThrown);
                    })
        });

        panel.on('hidePanel', () => {
            $(this).trigger("hidePanel", {customerId: this.customerId, changed: this.changed});
            this.customerId = null;
            this.changed = false;
        });

        panel.detailsTab.details.auditHistory.on(AuditHistoryView.LoadAuditRecrodsEvent, (event, {offset}) => {
            if (!this.state.allAuditHistoryLoaded || offset === 0) {
                makeRpcCall("CustomerInfoService.getAuditActions",
                        [this.customerId, AuditHistoryView.RECORD_LIMIT, offset],
                        result => {
                            this.setState({
                                allAuditHistoryLoaded: result['auditActions'].list.length < AuditHistoryView.RECORD_LIMIT,
                            })
                            if (offset > 0) {
                                panel.detailsTab.details.addAuditRecords(resolveAuditActions(result['auditActions'].list, result['dependencies'].list),
                                    AuditEntityTypes['CUSTOMER']);
                            } else {
                                panel.detailsTab.details.setAuditRecords(resolveAuditActions(result['auditActions'].list, result['dependencies'].list), AuditEntityTypes['CUSTOMER'])
                            }
                        });
            }
        })

        const updateAssignedUsersErrorHandler = e => {
            if (e instanceof NotFoundError) alert(messageResource.getMessage("customer.edit.error.concurrently_deleted"))
            if (e instanceof NoRightsError) alert(messageResource.getMessage("customer.error.customer_not_assigned"))
            if (e instanceof NoEditHierarchyRightError) alert(messageResource.getMessage("task.list.error.no_manage_scope_right"))
            if (e instanceof NotAssignedError) alert(messageResource.getMessage("task.list.error.user_is_not_assigned_to_manager"))
            if (e instanceof NoSubmitTTRightError) alert(messageResource.getMessage("task.list.error.user_does_not_have_submit_tt_right"))
            if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
            if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))

            window.location.reload()
        }

        const updateManagersErrorHandler = e => {
            if (e instanceof NotFoundError) alert(messageResource.getMessage("customer.edit.error.concurrently_deleted"));
            if (e instanceof NoManageUsersRightError) alert(messageResource.getMessage("task.list.error.no_manage_users_right"));
            if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))
            if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
            if (e instanceof NoAccessToScopeError) alert(messageResource.getMessage("task.list.error.user_does_not_have_any_scope_rights"))
            window.location.reload()
        }

        const assignedUsersEditor = panel.assignedUsersEditorContainer;
        panel.on('assignedUserDelete', (e, {userId}) => {
            applyActionResultToAssignedUsersEditor(
                assignedUsersEditor,
                customerActionsProvider.updateAssignedUsers(this.customerId, [], [userId])
            ).catch(updateAssignedUsersErrorHandler)
        })
        panel.on('assignedUsersChange', (e, {addedUserIds, removedUserIds}) => {
            applyActionResultToAssignedUsersEditor(
                assignedUsersEditor,
                customerActionsProvider.updateAssignedUsers(this.customerId, addedUserIds, removedUserIds)
            ).catch(updateAssignedUsersErrorHandler)
        })

        const managersEditor = panel.managersEditorContainer;
        panel.on('managerDelete', (e, {userData}) => {
            applyActionResultToAssignedUsersEditor(
                managersEditor,
                customerActionsProvider.updateManagers(this.customerId, [], [userData.id])
            ).then(() => {
                    applyActionResultToAssignedUsersEditor(
                        assignedUsersEditor,
                        customerActionsProvider.getAssignedUsers(this.customerId)
                    )
                    const userName = UserNameFormat.formatFML(userData.firstName, userData.lastName, userData.middleName)
                    this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.revoke_manage_customer_from_user", [userName]))
                }
            ).catch(updateManagersErrorHandler)
        })
        panel.on('managersChange', (e, {addedUserIds, removedUserIds}) => {
            applyActionResultToAssignedUsersEditor(
                managersEditor,
                customerActionsProvider.updateManagers(this.customerId, addedUserIds, removedUserIds)
            ).then(() => {
                    applyActionResultToAssignedUsersEditor(
                        assignedUsersEditor,
                        customerActionsProvider.getAssignedUsers(this.customerId)
                    )
                }
            ).catch(updateManagersErrorHandler)

            if (removedUserIds.length === 1) {
                const user = managersEditor.state.users.find(u => u.id === removedUserIds[0])
                const userName = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName)
                this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.revoke_manage_customer_from_user", [userName]))
            } else if (removedUserIds.length > 1) {
                this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.n_users_no_longer_manage_customer", [removedUserIds.length]))
            }
        })
    }

    _abortLoadPanelRequest() {
        if (this.loadPanelRequest)
            this.loadPanelRequest.abort();
    }

    loadData(customerId) {
        this._abortLoadPanelRequest()
        this.customerId = customerId;

        const panel = this.panel;

        panel.header.actions.hideMenu();
        this.loadingContainer.setState({loading: true})
        const errorHandler = (jqXHR, textStatus, errorThrown) => {
            if (this.state.openedFromUrl &&  [
                'com.actimind.actitime.customer.NoSuchCustomerException',
                'com.actimind.actitime.customer.CustomerUnavailableException'].includes(errorThrown.exception)) {
                this.actions.warning(messageResource.getMessage('customer.edit_panel.cannot_viewed_from_url'))
                this.hidePanel()
                return true
            }

            if (errorThrown.exception === "com.actimind.actitime.customer.NoSuchCustomerException") {
                if (customerId === this.customerId) {
                    alert(messageResource.getMessage("project.edit.customer_deleted_concurrently"));
                }
                this.actions.onCustomerDeleted(customerId)
                this.hidePanel();
                return true;
            } else if (errorThrown.exception === "com.actimind.actitime.customer.CustomerCannotBeModifiedException") {
                alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                this.hidePanel();
                return true;
            } else if (errorThrown.exception === "com.actimind.actitime.customer.CustomerUnavailableException") {
                alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                CustomerStore.remove(customerId);
                this.hidePanel();
                return true;
            }
            return false;
        };
        this.loadPanelRequest = makeRpcCall("CustomerInfoService.getCustomerInfo",
                [customerId],
                data => {
                    this.setState({
                        ...data,
                        allAuditHistoryLoaded: false,
                    })
                    this.loadingContainer.setState({loading: false})
                    this.panel.update(data);
                    this._onCustomerInfoReceived(data)
                    this.getAuditInfo();
                    this.actions.loadComments()
                },
                errorHandler);
    }

    _onCustomerInfoReceived(data) {
        this.actions.setAllProjectsAssigned(data.customerInfo.allProjectsAssigned)
        this.actions.setCanManageCustomer(!data.customerInfo.readOnly)
    }

    getAuditInfo() {
        if (!this.customerId) return

        const details = this.panel.detailsTab.details;
        details.clearAuditHistory();

        const dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
        const formatDate = (date) => Date.parseJSONTime(date).format(dateFormat)

        makeRpcCall("CustomerInfoService.getLastAuditActionsInfo",
                [this.customerId],
                result => {
                    let createAction = result['createAction'];
                    if (_.isNull(createAction))
                        createAction = {
                            timestamp: this.state.customerInfo['creationTimestamp'],
                            type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
                            data: null,
                            subject: null
                        };
                    const updateAction = result['updateAction'];
                    details.setAuditHistory(createAction, updateAction);
                })
    }

    hidePanel() {
        this._abortLoadPanelRequest()
        this.panel.setState({customerId: null})
        this.panelContainer.setState({isShown: false})
    }

    showPanel(customerId) {
        this.panelContainer.setState({isShown: true})
        this.panel.setState({customerId})
    }

    _updateDescription(description) {
        this._makeUpdateRequest("CustomerInfoService.setCustomerDescription", [this.customerId, description], this.panel.detailsTab.description)
    }

    _makeUpdateRequest(service, params, targetControl, forceCompleteTasks, statusId) {
        const customerId = this.customerId;
        targetControl.setLoading(true);
        const paramsCopy = params.slice();
        if (!_.isUndefined(forceCompleteTasks)) {
            paramsCopy.push(forceCompleteTasks);
            paramsCopy.push(statusId);
            let statusName = null;
            if (statusId != null)
                statusName = unsafe_selectWithState((state) => selectStatusById(state, statusId)).name;

            paramsCopy.push(statusName);
        }

        makeRpcCall(service,
            paramsCopy,
            data => {
                const config = data.customerInfo;
                // customer set archived => update its projects status
                const customer = {
                    id: config.id,
                    name: config.name,
                    archived: !config.active
                }
                if (config.active !== this.state.customerInfo.active) {
                    this.actions.toast(messageResource.getMessage("status.customer.toast", [customer.name]));
                }

                if (!config.active && this.state.customerInfo.active) {
                    this.actions.onCustomerArchived(customer.id)
                }
                this.setState(data);
                CustomerStore.add(customer);
                this.actions.onCustomerChanged(customer)
                this.changed = true;

                this.panel.update(data);
                this.panel.setFakeLastAudit()
                targetControl.setLoading(false)
                this.panel.openLastSelectedTab()
            },
            (jqXHR, textStatus, errorThrown) => {
                targetControl.setLoading(false)
                if (errorThrown.exception === 'com.actimind.actitime.customer.TasksNotArchivedException') {
                    if (this.state.isTWSEnabled) {
                        this.panel.openTabByKey(CustomerPanelDialogs.ARCHIVE_DIALOG)
                        this.panel.archiveDialog.setState({
                            openTaskNumber: errorThrown.taskCount,
                            statusId: unsafe_selectWithState((state) => selectFirstStatusByType(state, WorkflowStatusType.COMPLETED)).id,
                        });
                    } else {
                        const message = errorThrown.taskCount > 1 ?
                                        messageResource.getMessage("task.error.complete_tasks.customer_archive", [errorThrown.taskCount]) :
                                        messageResource.getMessage("task.error.complete_one_task.customer_archive");

                        if (confirm(message)) {
                            this._makeUpdateRequest(service, params, targetControl, true, null);
                        }
                        else {
                            this.panel.update(this.state);
                        }
                    }

                    return true;
                }

                if (errorThrown.exception === "com.actimind.actitime.administration.WorkflowStatusChangedExceptions") {
                    alert(messageResource.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                    window.location.reload();
                    return true
                }
                if (errorThrown.exception === "com.actimind.actitime.administration.NoSuchWorkflowStatusException") {
                    alert(messageResource.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                    window.location.reload();
                    return true;
                }

                if (errorThrown.exception === "com.actimind.actitime.services.NoRightToEditHierarchyException") {
                    alert(messageResource.getMessage("change_tasks_workflow_status.no_manage_scope_right"));
                    window.location.reload();
                    return true;
                }

                return this._errorHandler(customerId, jqXHR, textStatus, errorThrown);
            });
    }

    _errorHandler(customerId, jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception === "com.actimind.actitime.customer.NoSuchCustomerException") {
            if (customerId === this.customerId) {
                alert(messageResource.getMessage("customer.edit.cannot_edit_deleted_concurrently"));
            }
            this.actions.onCustomerDeleted(customerId)
            this.hidePanel();
            return true;
        }

        if (errorThrown.exception === "com.actimind.actitime.customer.CustomerUnavailableException") {
            //TODO change message
            if (customerId === this.customerId) {
                alert(messageResource.getMessage("customer.edit.cannot_edit_deleted_concurrently"));
            }
            this.actions.onCustomerDeleted(customerId)
            this.hidePanel();
            return true;
        }

        if (errorThrown.exception === "com.actimind.actitime.customer.CustomerExistsException") {
            if (customerId === this.customerId) {
                this.panel.header.nameInput.setState({
                    invalid: true,
                    focus: true,
                    errorText: messageResource.getMessage("customer.edit.error.name_duplicate")
                })
            }
            return true;
        }
        if (errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
            if (customerId === this.customerId) {
                var alertText = messageResource.getMessage(this.state.customerInfo.canManageAllUsersWithoutAutoApproved ?
                                                           "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" :
                                                           "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time",
                    [messageResource.getMessage("common.customer")]);
                alert(alertText);
                this.panel.header.actions.disableDeleteButton(alertText);
                this.panel.openLastSelectedTab()
            }
            return true;
        }
        if (errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
            if (customerId === this.customerId) {
                const alertText = messageResource.getMessage("customer.edit.cannot_delete_due_to_lock_time");
                alert(alertText);
                this.panel.header.actions.disableDeleteButton(alertText);
                this.panel.openLastSelectedTab()
            }
            return true;
        }
        return false;
    };
}

export default connect(
    state => ({
        customerId: getOpenCustomerId(state),
        openedFromUrl: isPanelOpenedFromUrl(state),

        isWASEnabled: isWASEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
    }),
    dispatch => ({
        onCustomerArchived: bindActionCreators(archiveProjectsOfCustomerAndReloadTasks, dispatch),
        onCustomerChanged: bindActionCreators(addCustomer, dispatch),
        onCustomerDeleted: bindActionCreators(removeCustomer, dispatch),
        loadComments: bindActionCreators(reloadComments, dispatch),
        setAllProjectsAssigned: bindActionCreators(setAllProjectsAssigned, dispatch),
        setCanManageCustomer: bindActionCreators(setCanManageCustomer, dispatch),
        copyLink: bindActionCreators(copyLinkTo, dispatch),
        toast: bindActionCreators(toast, dispatch),
        warning: bindActionCreators(warning, dispatch),
    })
)(CustomerPanelController)


// WEBPACK FOOTER //
// ./web/js/panels/customer/CustomerPanelController.js